module.exports = __webpack_public_path__ + "static/masters-of-doom-393abf6d0f4b72e674dc78cee13bd5b8.jpg";